/*=========================================================================================
  File Name: moduleMapState.js
  Description: Todo Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	alarms: [],
	batteryAlarms: [],
	pagination: {
		next_page: 0,
		total_pages: 0,
		total_records: 0,
	},
};
